// messageCenter/ticketText.js — the topoEditor entities of ticket texts (description, comments): the notice entities
// (links, document links {id}, noticeText.js) plus ticket references T#123 (decision D-16). Shared by the inbox page and
// the quick report on every backend page, so it stays small: no page code in here.
import { ticketRefEntity } from '../topoEditor/entities/ticketRef.js';
import { noticeTextEntities } from './noticeText.js';

/** Ticket references link into the inbox page (?ticket=<n>); on the page itself the controller catches the click. */
export function ticketTextEntities({ ticketHref = (id) => '?ticket=' + encodeURIComponent(id) } = {}) {
    return [...noticeTextEntities(), ticketRefEntity({ hrefFor: ticketHref })];
}
